import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {PotvrdaOSprecenostiZaRadDocument} from "./PotvrdaOSprecenostiZaRadDocument";
import {ZahtevZaOdsustvovanjeDocument} from "./ZahtevZaOdsustvovanjeDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, zaposleni, sektor
// opciono: period odsustva
export const zahtevZaOdsustvovanjeDocumentFields: IntercateKeysMap<ZahtevZaOdsustvovanjeDocument, EntityField<ZahtevZaOdsustvovanjeDocument>> = {
	...baseDocumentFields,
	employeeId: {
		name: "employeeId", dataType: EntityFieldDataType._reference, label: "Zaposleni",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Employees
		},
		validator: { required: true },
		sortable: true
	},
	period: {
		name: "period", dataType: EntityFieldDataType._string, label: "Period odsustva",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.employeeId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<ZahtevZaOdsustvovanjeDocument>> = [
	zahtevZaOdsustvovanjeDocumentFields.indexingNumber,
	zahtevZaOdsustvovanjeDocumentFields.indexingDate,
	zahtevZaOdsustvovanjeDocumentFields.documentNumber,
	zahtevZaOdsustvovanjeDocumentFields.documentDate,
	zahtevZaOdsustvovanjeDocumentFields.assignedTo,
	zahtevZaOdsustvovanjeDocumentFields.sectorId,
	zahtevZaOdsustvovanjeDocumentFields.employeeId,
	zahtevZaOdsustvovanjeDocumentFields.period,
	zahtevZaOdsustvovanjeDocumentFields.tags,
	zahtevZaOdsustvovanjeDocumentFields.description,
	zahtevZaOdsustvovanjeDocumentFields.parentId,
]

export const zahtevZaOdsustvovanjeDocumentFieldsDescriptor: EntityFieldsDescriptor<ZahtevZaOdsustvovanjeDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
